import {
  Button,
  Drawer,
  DrawerContent,
  HStack,
  IconButton,
  VStack,
  useDisclosure,
} from "@chakra-ui/react";
import React from "react";
import { MenuIcon } from "../../icons/MenuIcon";
import { LogoIcon } from "../../icons/LogoIcon";
import { CloseIcon } from "../../icons/CloseIcon";
import { DownloadIcon } from "../../icons/DownloadIcon";
import { GrayLogoIcon } from "../../icons/GrayLogoIcon";

export const MobileNavBar = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  return (
    <HStack
      display={["flex", "flex", "none"]}
      justifyContent="space-between"
      w="full"
      alignItems="center"
      position="fixed"
      top={0}
      zIndex={99999}
    >
      <HStack
        w="full"
        py="24px"
        px="20px"
        justifyContent="space-between"
        alignItems="center"
        bgColor={"primary.1000"}
        zIndex={999999}
        borderBottom="1px solid"
        borderColor="primary.800"
      >
        <LogoIcon h={12} w={28} />
        <IconButton
          icon={
            isOpen ? (
              <CloseIcon color="#fff" h={8} w={8} />
            ) : (
              <MenuIcon color="#fff" h={8} w={8} />
            )
          }
          aria-label="Menu"
          variant={"unstyled"}
          bgColor={"transparent"}
          onClick={isOpen ? onClose : onOpen}
        />
      </HStack>
      <Drawer isOpen={isOpen} placement="top" size="full" onClose={onClose}>
        <DrawerContent
          bgColor={"primary.1000"}
          color={"white"}
          zIndex={999999}
          pt={40}
        >
          <VStack
            w="full"
            justifyContent="flex-start"
            alignItems="center"
            gap={10}
            h="full"
            px={10}
          >
            <Button
              variant="unstyled"
              h="auto"
              p={2}
              fontSize="xx-large"
              textAlign="left"
              w="full"
              onClick={onClose}
            >
              <a href="#about">Quiero viajar</a>
            </Button>
            <Button
              variant="unstyled"
              h="auto"
              p={2}
              fontSize="xx-large"
              textAlign="left"
              w="full"
              onClick={onClose}
            >
              <a href="#driver">Quiero conducir</a>
            </Button>
            <Button
              variant="unstyled"
              h="auto"
              p={2}
              fontSize="xx-large"
              textAlign="left"
              w="full"
              onClick={onClose}
            >
              <a href="#corporations">Empresas</a>
            </Button>
            <Button
              variant="unstyled"
              h="auto"
              p={2}
              fontSize="xx-large"
              textAlign="left"
              w="full"
              onClick={onClose}
            >
              <a href="#download">
                Descargá ViajáYa <DownloadIcon ml={4} h={6} w={6} />
              </a>
            </Button>
          </VStack>
          <HStack px={10} justifyContent="center" alignItems="center">
            <GrayLogoIcon w={40} h={40} />
          </HStack>
        </DrawerContent>
      </Drawer>
    </HStack>
  );
};
